import { render, staticRenderFns } from "./KnowledgeBaseCategoryList.vue?vue&type=template&id=62c71f22&"
import script from "./KnowledgeBaseCategoryList.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports